module.exports = __webpack_public_path__ + "img/Loading.130a4ed8.gif";